import { Box, styled } from "@mui/material";

export const MetricOpportunityContainer = styled(Box)({
    height: "90vh",
    display: "flex",
    flexDirection: "column",
})

export const NoGroupWrapper = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    // border: "1px solid red"
})